/** Qualified (Amy) chatbot — single source for script URL used by preload + loader. */ export const QUALIFIED_CHATBOT_SCRIPT_SRC = "https://js.qualified.com/qualified.js?token=fcBTsAJLpnZhBHvP";
export const QUALIFIED_CHATBOT_ORIGIN = "https://js.qualified.com";
